import { Component, Input, OnChanges, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomModalWithCountrySelectionComponent } from './custom-modal-with-country-selection/custom-modal-with-country-selection.component';
import { ModalController } from '@ionic/angular';
import { countries } from './mock-countries';
import { normalizePhoneCountryCode } from 'src/app/utils/customer-profile.utils';

@Component({
	selector: 'app-input-phone-with-county-code',
	templateUrl: './input-phone-with-county-code.component.html',
	styleUrls: ['./input-phone-with-county-code.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => InputPhoneWithCountyCodeComponent),
			multi: true,
		},
	],
})
export class InputPhoneWithCountyCodeComponent implements ControlValueAccessor, OnInit, OnChanges {
	countryCode = '+49';
	flag = 'de';
	@Input() code: string;
	@Input() phone: string;
	@Input() hasBackground: boolean = true;
	onChange: any = () => {};
	onTouched: any = () => {};
	form: FormGroup;

	constructor(
		private fb: FormBuilder,
		private modalCtrl: ModalController
	) {
		this.form = this.fb.group({
			phone: '',
			country: '',
		});
	}

	ngOnInit() {
		// this.form.patchValue(
		// 	{
		// 		country: '+49',
		// 	},
		// 	{ emitEvent: true }
		// );
		this.form.valueChanges.subscribe(result => {
			this.onChange({
				phone: this.form.get('phone')?.value?.toString()?.trim() ?? '',
				country: normalizePhoneCountryCode(this.form.get('country')?.value),
			});
		});
	}
	ngOnChanges(changes: SimpleChanges): void {}
	writeValue(value: { country: string; phone: string }): void {
		const country = normalizePhoneCountryCode(value?.country);
		this.form.patchValue(
			{
				country,
				phone: value?.phone ?? '',
			},
			{ emitEvent: true }
		);
		if (country) {
			this.flag = countries.find(it => normalizePhoneCountryCode(it.dialCode) === country)?.flagClass ?? '';
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	async selectCountryCode() {
		const result = await CustomModalWithCountrySelectionComponent.show(this.modalCtrl, this.form.get('country')?.value);
		if (result?.dialCode) {
			this.flag = result.flagClass;
			this.form.patchValue(
				{
					country: normalizePhoneCountryCode(result.dialCode),
				},
				{ emitEvent: true }
			);
		}
	}
}
